import { useShowNotification } from '@inflearn/ds-react-next';
import { API_ENDPOINT, useClientApiV1ClipsCreateMutation } from '../../resources/@types/uccSchema';
import { logger } from '../../resources/Logger';
import { COURSE_URL } from '../constants/urls';

interface UseClientV1ClipsMutation {
  options?: Parameters<typeof useClientApiV1ClipsCreateMutation>[0]['options'];
}

export function useClipsCreateMutation({ options }: UseClientV1ClipsMutation) {
  const { showNotification } = useShowNotification();

  return useClientApiV1ClipsCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_CLIPS,
    options: {
      ...options,
      onSuccess: (res) => {
        if (res.data) {
          window.location.href = COURSE_URL.CLIP_EDIT_CLIP_ID({ clipId: res.data.id });
          return;
        }
      },
      onError: (error) => {
        logger.error(error);
        showNotification({
          title: '클립 생성에 실패했습니다.',
          type: 'error',
        });
      },
    },
  });
}
